import { FC } from 'react'
import styled, { css } from 'styled-components'
import { ActivityFilterItemById } from 'generated/graphql'
import { SelectedItem } from '@app.feature/jobCategory/component/selectedItem'
import OldChip from 'components/OldChip'
import { FilterByKeys } from '../../context'
import RecruitFilterChipPc from './RecruitFilterChip.pc'
import { useRecruitFilterChips } from './RecruitFilterChips.module'
import ResetButton from './ResetButton'

interface FilterListItem<T = ActivityFilterItemById> {
  filterTitle: string
  filterItems: Array<T>
  filterKey: FilterByKeys
}

interface RecruitFilterChipsProps {
  filterList: FilterListItem[]
}

const RecruitFilterChips: FC<RecruitFilterChipsProps> = (props) => {
  const { filterList } = props

  const {
    filterIsEmpty,
    selectedFilterPcItems,
    selectedCategories,
    keyword,
    onReset,
    onChipRemove,
    onKeywordDelete,
  } = useRecruitFilterChips(filterList)

  return (
    <StyledWrapper>
      {selectedFilterPcItems.map((item, index) => (
        <RecruitFilterChipPc
          key={`selected_filter_chip_${item.id}_${index}`}
          fieldKey={item.fieldKey}
          onClick={() => {
            onChipRemove(item)
          }}
          item={item}
        />
      ))}
      {selectedCategories.map((category, index) => {
        const removeCategoryItem = {
          fieldKey: 'categoryIDs' as FilterByKeys,
          id: category.id,
          name: category.name,
        }

        return (
          <SelectedItem
            key={`selected_categories_chip_${category.id}_${index}`}
            category={category}
            onDelete={() => {
              onChipRemove(removeCategoryItem)
            }}
          />
        )
      })}
      {keyword && (
        <OldChip
          className="keyword-chip"
          color="primary"
          size="small"
          onDelete={onKeywordDelete}
          label={`검색어 - ${keyword}`}
        />
      )}
      {!filterIsEmpty && <ResetButton onClick={onReset} />}
      {filterIsEmpty && (
        <div className="text-empty-helper">
          상세필터를 선택해 관심있는 공고를 쉽게 찾아보세요.
        </div>
      )}
    </StyledWrapper>
  )
}

export default RecruitFilterChips

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    min-height: 76px;
    margin-right: 51px;
    padding: 20px;
    border: 1px solid ${theme.line.line_2};
    border-top: none;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;

    .keyword-chip {
      height: 35px;
    }

    .text-empty-helper {
      font-weight: 500;
      font-size: 12px;
      color: ${theme.color.text_2};
    }
  `}
`
